import React from 'react';
import {
  FDBox,
  FDHeadlineText,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { DataValueMap } from 'Helpers/Testing';
import TimelineConnector from './TimelineConnector';

const useStyles = makeStyles(theme => ({
  timelineEventDot: {
    height: '15px',
    width: '15px',
    backgroundColor: theme.palette.facet.primaryBlue,
    borderRadius: '50px',
  },
}));

export default function MobileTimelineItem({
  itemResource, month, timelineCardComponent, isFirstItem,
}) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const TimelineCardComponent = timelineCardComponent;

  return (
    <FDStack direction={'column'} alignItems={'center'}>
      <TimelineConnector />
      <Box className={classes.timelineEventDot} />
      <FDBox paddingY={0.5}>
        {month !== '' ? <FDHeadlineText {...DataValueMap.init('timeline-month').build()} size="md" value={month} /> : null}
      </FDBox>
      <TimelineConnector />
      <TimelineCardComponent resource={itemResource} expanded={isFirstItem} />
    </FDStack>
  );
}

MobileTimelineItem.defaultProps = {
  month: '',
  isFirstItem: false,
  isLastItem: false,
};

MobileTimelineItem.propTypes = {
  itemResource: PropTypes.object.isRequired,
  month: PropTypes.string,
  timelineCardComponent: PropTypes.element.isRequired,
  isFirstItem: PropTypes.bool,
  isLastItem: PropTypes.bool,
};
